import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { IBillingShippingModel, SCALType } from "../../../interfaces/LicenseModel";
import { apply } from "core-js/fn/reflect";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'generate-scal360-license',
    styles:[require('./generate-scal360-license.component.css')],
    template:require('./generate-scal360-license.component.html')
})
export class GenerateSCAL30LicenseComponent{
    dialogTitle='';
    errorMessage='';
    scal360LicenseForm:FormGroup;
    isRadioButtonDisabled=false;
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    isBillingShippingDetailFetched=false;
    customerId=0;
    shippingAddressId=0;
    shouldFetchSalesOrderNo=false;
    scal360LicenseDisplayList;
    SelectedCustomerLicenseDetail;
    SCALOperation;
    error="";
    isLoading=false;
    SCALTypeList=[];
    prevSalesOrderNo='';
    constructor(
        private dialogRef:MdDialogRef<GenerateSCAL30LicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData: any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.SCALOperation=this.dialogData.scalOperation;
        Object.keys(SCALType).filter((type) => isNaN(Number(type))).forEach((key,index)=>{
            this.SCALTypeList.push({
                name:key,
                value:SCALType[key]
            })
        })
        if(this.SCALOperation==2){
            this.dialogTitle="Edit License Request";
            this.isRadioButtonDisabled=true;
            this.scal360LicenseForm.patchValue({
                NoOfLicensePurchased:this.SelectedCustomerLicenseDetail.NoOfLicensePurchased,
                NoOfUserLicensePurchased:this.SelectedCustomerLicenseDetail.NoOfUserLicensePurchased,
                ScalType:SCALType[this.SelectedCustomerLicenseDetail.SCALType],
                LicenseType:this.SelectedCustomerLicenseDetail.LicenseType,
                SupportValidityYear:this.SelectedCustomerLicenseDetail.SupportValidityYears,
                PurchaseDate:this.SelectedCustomerLicenseDetail.PurchaseInvoiceDate.split('T')[0],
                SalesOrderNo:this.SelectedCustomerLicenseDetail.SalesOrderNo,
            })
            this.isBillingShippingDetailFetched=true;
            this.prevSalesOrderNo=this.SelectedCustomerLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName=this.SelectedCustomerLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedCustomerLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedCustomerLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedCustomerLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedCustomerLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedCustomerLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedCustomerLicenseDetail.ShipToState;
        }
        else if(this.SCALOperation==3){
            this.dialogTitle="Add More License Request";
            this.isRadioButtonDisabled=true;
            this.scal360LicenseForm.patchValue({
                ScalType:SCALType[this.SelectedCustomerLicenseDetail.SCALType],
                LicenseType:this.SelectedCustomerLicenseDetail.LicenseType
            })
            this.isBillingShippingDetailFetched=true;
            this.prevSalesOrderNo=this.SelectedCustomerLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName=this.SelectedCustomerLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedCustomerLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedCustomerLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedCustomerLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedCustomerLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedCustomerLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedCustomerLicenseDetail.ShipToState;
        }
        else{
            this.scal360LicenseForm.get('NoOfLicensePurchased').setValidators([Validators.required,Validators.max(100),Validators.min(1)])
            this.dialogTitle='Generate New License Request';
        }
        
    }
    buildForm(){
        this.scal360LicenseForm=this.formBuilder.group({
            NoOfLicensePurchased:[1,[Validators.required,Validators.max(100)]],
            NoOfUserLicensePurchased:[0,[Validators.required,Validators.max(100)]],
            SalesOrderNo:['',[Validators.required]],
            ScalType:[1,Validators.required],
            LicenseType:['NEW',Validators.required],
            PurchaseDate:['',Validators.required],
            SupportValidityYear:[24,Validators.required]
        })
    }
    blurSalesOrderEvent(){
        if(this.prevSalesOrderNo.trim().toUpperCase()==this.scal360LicenseForm.value.SalesOrderNo.trim().toUpperCase()){
            return;
        }
        this.prevSalesOrderNo=this.scal360LicenseForm.value.SalesOrderNo
        setTimeout(() => {
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
        }, 150);
    }
    checkSalesOrderNo(){
        if(this.dialogData.Scal360LicenseData){
            let exist=this.dialogData.Scal360LicenseData.some((element)=>{
                if(element.SalesOrderNo!=null){
                    return this.scal360LicenseForm.value.SalesOrderNo.trim().toUpperCase()==element.SalesOrderNo.trim().toUpperCase()
                }
                else{
                    return false;
                }
            });

            if(exist){
                Swal.fire({
                    title:"This sales order no already exists",
                    text:"Are you sure you want to use this Sales Order No?",
                    showCancelButton:true,
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonText:"Yes",
                    confirmButtonColor:"#FFCA28",
                    cancelButtonText:"No",
                }).then((result)=>{
                    if(result.isConfirmed){
                       this.shouldFetchSalesOrderNo=true;
                       this.isBillingShippingDetailFetched=false;
                       this.getBillingShippingDetail();
                    }
                    else{
                        this.shouldFetchSalesOrderNo=false;
                        this.scal360LicenseForm.patchValue({
                            SalesOrderNo:""
                        });
                    }
                })
            }
            else{
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
                this.getBillingShippingDetail();
            }
        }
        else{
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
            this.getBillingShippingDetail();
        }
    }

    getBillingShippingDetail(){
        let salesOrderNo=this.scal360LicenseForm.value.SalesOrderNo;
        if(salesOrderNo!=''){
            if(this.shouldFetchSalesOrderNo){
                this.appLoader.open()
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.billingShippingDetail=data.DataObject;
                        this.isBillingShippingDetailFetched=true;
                        this.error='';
                    }
                    else{
                        this.isBillingShippingDetailFetched=false;
                        this.error=data.Error;
                    }
                    this.appLoader.close();
                })
            }
            else{
                this.error="Please select other sales order number."
            }
        }
        else{
            this.error="Sales Order No is required";
            this.isBillingShippingDetailFetched=false;
        }
    }
    onSave(){
        setTimeout(() => {
            if(!this.isBillingShippingDetailFetched){
                this.error="Please fetch the customer billing and shipping details!";
                return;
            }
            else{
                if(this.SCALOperation==2){ //edit license request
                    this.appLoader.open()
                    if(this.SelectedCustomerLicenseDetail.SalesOrderNo.toUpperCase()===this.scal360LicenseForm.value.SalesOrderNo.toUpperCase()){
                        let model={
                            CustomerId:this.SelectedCustomerLicenseDetail.CustomerId,
                            ShippingAddressId:this.SelectedCustomerLicenseDetail.ShippingAddressId,
                            SCALType:SCALType[this.scal360LicenseForm.value.ScalType],
                            LicenseType:this.scal360LicenseForm.value.LicenseType,
                            SupportValidityYear:this.scal360LicenseForm.value.SupportValidityYear,
                            PurchaseInvoiceDate:this.scal360LicenseForm.value.PurchaseDate,
                            SalesOrderNo:this.scal360LicenseForm.value.SalesOrderNo,
                            NoOfLicensePurchased:this.scal360LicenseForm.value.NoOfLicensePurchased,
                            NoOfUserLicensePurchased:this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                            PurchaseId:this.SelectedCustomerLicenseDetail.PurchaseId,
                            LicenseId:this.SelectedCustomerLicenseDetail.LicenseId,
                            UpdatedBy:Number(localStorage.getItem('userid'))
                        }
                        this.licenseService.updateScalPurchaseLicense(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.scal360LicenseDisplayList=data.DataObject;
                                this.dialogRef.close(this.scal360LicenseDisplayList);
                                this.appLoader.close();
                                this.snackBar.open("License Updated successfully!","",{
                                    duration:2000
                                })
                            }
                            else{
                                this.appLoader.close();
                                this.dialogRef.close(this.scal360LicenseDisplayList);
                            }
                        })
                    }
                    else{
                        this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.customerId=data.DataObject.CustomerId;
                                this.shippingAddressId=data.DataObject.ShippingAddressId;
                                let model={
                                    CustomerId:data.DataObject.CustomerId,
                                    ShippingAddressId:data.DataObject.ShippingAddressId,
                                    SCALType:SCALType[this.scal360LicenseForm.value.ScalType],
                                    LicenseType:this.scal360LicenseForm.value.LicenseType,
                                    SupportValidityYear:this.scal360LicenseForm.value.SupportValidityYear,
                                    PurchaseInvoiceDate:this.scal360LicenseForm.value.PurchaseDate,
                                    SalesOrderNo:this.scal360LicenseForm.value.SalesOrderNo,
                                    NoOfLicensePurchased:this.scal360LicenseForm.value.NoOfLicensePurchased,
                                    NoOfUserLicensePurchased:this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                                    PurchaseId:this.SelectedCustomerLicenseDetail.PurchaseId,
                                    LicenseId:this.SelectedCustomerLicenseDetail.LicenseId,
                                    UpdatedBy:Number(localStorage.getItem('userid'))
                                }
                                this.licenseService.updateScalPurchaseLicense(model).subscribe((data)=>{
                                    if(!data.IsError && data.DataObject!=null){
                                        this.scal360LicenseDisplayList=data.DataObject;
                                        this.dialogRef.close(this.scal360LicenseDisplayList);
                                        this.appLoader.close();
                                        this.snackBar.open("License Updated successfully!","",{
                                            duration:2000
                                        })
                                    }
                                    else{
                                        this.appLoader.close();
                                        this.dialogRef.close(this.scal360LicenseDisplayList);
                                    }
                                })
                            }
                        })
                    }
                }
                else if(this.SCALOperation==3){  //add more license request
                    this.appLoader.open()
                    if(this.SelectedCustomerLicenseDetail.SalesOrderNo.toUpperCase()===this.scal360LicenseForm.value.SalesOrderNo.toUpperCase()){
                        let model={
                            CustomerId:this.SelectedCustomerLicenseDetail.CustomerId,
                            ShippingAddressId:this.SelectedCustomerLicenseDetail.ShippingAddressId,
                            SCALType:SCALType[this.scal360LicenseForm.value.ScalType],
                            LicenseType:this.scal360LicenseForm.value.LicenseType,
                            SupportValidityYear:this.scal360LicenseForm.value.SupportValidityYear,
                            PurchaseInvoiceDate:this.scal360LicenseForm.value.PurchaseDate,
                            SalesOrderNo:this.scal360LicenseForm.value.SalesOrderNo,
                            NoOfLicensePurchased:this.scal360LicenseForm.value.NoOfLicensePurchased,
                            NoOfUserLicensePurchased:this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                            PurchaseId:this.SelectedCustomerLicenseDetail.PurchaseId,
                            LicenseId:this.SelectedCustomerLicenseDetail.LicenseId,
                            UpdatedBy:Number(localStorage.getItem('userid'))
                        }
                        this.licenseService.addMoreScalLicense(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.scal360LicenseDisplayList=data.DataObject;
                                this.dialogRef.close(this.scal360LicenseDisplayList);
                                this.appLoader.close();
                                this.snackBar.open("License added successfully!","",{
                                    duration:2000
                                })
                            }
                            else{
                                this.appLoader.close();
                                this.dialogRef.close(this.scal360LicenseDisplayList);
                            }
                        })
                    }
                    else{
                        this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.customerId=data.DataObject.CustomerId;
                                this.shippingAddressId=data.DataObject.ShippingAddressId;
                                let model={
                                    CustomerId:data.DataObject.CustomerId,
                                    ShippingAddressId:data.DataObject.ShippingAddressId,
                                    SCALType:SCALType[this.scal360LicenseForm.value.ScalType],
                                    LicenseType:this.scal360LicenseForm.value.LicenseType,
                                    SupportValidityYear:this.scal360LicenseForm.value.SupportValidityYear,
                                    PurchaseInvoiceDate:this.scal360LicenseForm.value.PurchaseDate,
                                    SalesOrderNo:this.scal360LicenseForm.value.SalesOrderNo,
                                    NoOfLicensePurchased:this.scal360LicenseForm.value.NoOfLicensePurchased,
                                    NoOfUserLicensePurchased:this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                                    PurchaseId:this.SelectedCustomerLicenseDetail.PurchaseId,
                                    LicenseId:this.SelectedCustomerLicenseDetail.LicenseId,
                                    UpdatedBy:Number(localStorage.getItem('userid'))
                                }
                                this.licenseService.addMoreScalLicense(model).subscribe((data)=>{
                                    if(!data.IsError && data.DataObject!=null){
                                        this.scal360LicenseDisplayList=data.DataObject;
                                        this.dialogRef.close(this.scal360LicenseDisplayList);
                                        this.appLoader.close();
                                        this.snackBar.open("License Updated successfully!","",{
                                            duration:2000
                                        })
                                    }
                                    else{
                                        this.appLoader.close();
                                        this.dialogRef.close(this.scal360LicenseDisplayList);
                                    }
                                })
                            }
                        })
                    }
    
                }
                else{ //add new license request
                    this.appLoader.open();
                    this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.customerId=data.DataObject.CustomerId;
                            this.shippingAddressId=data.DataObject.ShippingAddressId;
                            let model={
                                CustomerId:data.DataObject.CustomerId,
                                ShippingAddressId:data.DataObject.ShippingAddressId,
                                SCALType:SCALType[this.scal360LicenseForm.value.ScalType],
                                LicenseType:this.scal360LicenseForm.value.LicenseType,
                                SupportValidityYear:this.scal360LicenseForm.value.SupportValidityYear,
                                PurchaseInvoiceDate:this.scal360LicenseForm.value.PurchaseDate,
                                SalesOrderNo:this.scal360LicenseForm.value.SalesOrderNo,
                                NoOfLicensePurchased:this.scal360LicenseForm.value.NoOfLicensePurchased,
                                NoOfUserLicensePurchased:this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                                CreatedBy:Number(localStorage.getItem('userid')),
                                UpdatedBy:Number(localStorage.getItem('userid'))
                            }
                            this.licenseService.generateScalLicense(model).subscribe((data)=>{
                                if(!data.IsError && data.DataObject!=null){
                                    this.scal360LicenseDisplayList=data.DataObject;
                                    this.appLoader.close();
                                    this.dialogRef.close(this.scal360LicenseDisplayList);
                                    this.snackBar.open("License generated successfully!","",{
                                        duration:2000
                                    })
                                }
                                else{
                                    this.appLoader.close();
                                    this.dialogRef.close(this.scal360LicenseDisplayList);
                                }
                            });
                        }
                    });
                }
            }  
        }, 300);
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/generate-scal360-license/generate-scal360-license.component.ts